import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'

export const getBankerCatchResultService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'system/applet-result', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
